<template>
  <detail-item
    icon="mdi-map-marker"
    name="Addresses"
    :name-spacing="nameSpacing"
  >
    <q-item-label v-if="addressList.length < 1" class="text-grey-7">
      No addresses to display
    </q-item-label>

    <div
      v-for="(address, key) in addressList"
      :key="key"
      class="q-pb-md"
    >
      <q-item-label class="text-bold">
        {{ address.field_name }} Address
      </q-item-label>

      <address-field
        ref="addressInput"
        :address="address"
        :dialog-title="'Set ' + address.field_name + ' Address'"
        :highlighted-icon="address.type === 'PRIMARY'"
        outlined
        dense
        single-line
        hide-bottom-space
        :error="addressHasError(key)"
        @clear="removeAddress(key)"
      >
        <q-item-label
          v-if="address.note"
          caption
        >
          {{ address.note }}
        </q-item-label>

        <template #dialog-before>
          <div class="row q-col-gutter-md">
            <div class="col-6">
              <q-item-label class="text-bold">
                Address Type <span class="required-astrx" />
              </q-item-label>
              <q-select
                :model-value="address.type"
                :options="addressTypeOptionsWithDisabled"
                map-options
                emit-value
                dense
                outlined
                behavior="menu"
                @update:model-value="(value) => onTypeSelect(address, value)"
              />
            </div>
            <div v-if="address.type === 'EXTRA'" class="col-6">
              <q-item-label class="text-bold">
                Label <span class="required-astrx" />
              </q-item-label>
              <q-input
                v-model="address.field_name"
                outlined
                dense
                hide-bottom-space
                :error="!address.field_name"
              />
            </div>
          </div>
        </template>

        <template #dialog-after>
          <q-item-label class="text-bold">
            Note
          </q-item-label>
          <q-input
            v-model="address.note"
            outlined
            dense
            placeholder="Enter Note..."
            type="textarea"
          />
        </template>
      </address-field>
    </div>

    <q-btn
      color="teal"
      icon="mdi-plus"
      label="Add Address"
      size="12px"
      class="q-mt-sm"
    >
      <q-menu>
        <q-card style="min-width: 150px;">
          <q-list dense>
            <q-item-label
              header
              class="text-bold q-py-sm"
            >
              Select Address Type:
            </q-item-label>
            <q-item
              v-for="(type, key) in addressTypeOptions"
              :key="key"
              v-close-popup
              clickable
              @click="addAddress(type.value)"
            >
              <q-item-section>{{ type.label }}</q-item-section>
            </q-item>
          </q-list>
        </q-card>
      </q-menu>
    </q-btn>
  </detail-item>
</template>

<script>
import PhoneAddressMixin from '../../../../../partials/PhoneAddressEmail'

export default {
  mixins: [PhoneAddressMixin],
  props: {
    addressList: {
      type: Array,
      required: true
    },
    nameSpacing: {
      type: Number
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    usedOptions () {
      return this.addressList.map(item => item.type).filter(item => item !== 'EXTRA')
    },
    addressTypeOptions () {
      return this.addressTypes.filter(item => !this.usedOptions.includes(item.value))
    },
    addressTypeOptionsWithDisabled () {
      return this.addressTypes
        .filter(item => item)
        .map(item => {
          item.disable = this.usedOptions.includes(item.value)
          return item
        })
    }
  },
  methods: {
    addressHasError (key) {
      return !!Object.keys(this.errors).find(item => item === ('addresses.' + key))
    },
    getFieldType (type) {
      const field = this.addressTypes.find(item => item.value === type)
      return {
        type: field.value,
        field_name: field.label
      }
    },
    addAddress (type) {
      const nextAddressType = this.getFieldType(type)
      this.addressList.push(this.getAddressPayload(true, {
        type: nextAddressType.type,
        field_name: nextAddressType.field_name
      }))

      this.timed(() => {
        this.$refs.addressInput[this.$refs.addressInput.length - 1].focus()
      }, 250)
    },
    removeAddress (key) {
      this.addressList.splice(key, 1)
    },
    onTypeSelect (address, value) {
      const item = this.addressTypeOptions.find(item => item.value === value)
      address.field_name = item.label
      address.type = item.value
    }
  },
  mounted () {
  }
}
</script>
